module.exports = __webpack_public_path__ + "img/PFA.a946e012.svg";